import { useEffect } from "react";
import { motion } from "framer-motion";
import { mountSportigo } from "@/lib/sportigo";
import { useContent } from "@/lib/content";

const GYM_ID = "5a2af1ed-f28d-4e38-884d-a266da75a3c2";
const DESC_KEYS = {
  abbonamenti: "abbonamenti_desc",
  coaching: "coaching_desc",
  "gift-card": "giftcard_desc",
};

export default function SportigoSection({ id, index, title, description, component, containerId, options }) {
  const c = useContent();
  const desc = c[DESC_KEYS[id]] ?? description;
  useEffect(() => {
    mountSportigo(component, containerId, GYM_ID, options);
  }, [component, containerId, options]);

  return (
    <section
      id={id}
      data-testid={`section-${id}`}
      className="px-6 md:px-16 py-24 md:py-32 border-t border-[rgba(176,132,51,0.15)]"
    >
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-col md:flex-row md:items-end gap-6 md:gap-12 mb-12"
        >
          <span className="font-editorial italic text-gold/60 text-3xl md:text-5xl leading-none">{index}</span>
          <div>
            <h2 className="font-display text-4xl md:text-6xl tracking-wide text-bone leading-[0.95]">
              {title.toUpperCase()}
            </h2>
            <p className="text-bone/60 text-sm md:text-base mt-3 max-w-2xl leading-relaxed">{desc}</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="bg-bone text-[#121212] p-4 md:p-8 border border-gold/40 shadow-[0_0_80px_rgba(176,132,51,0.08)]"
        >
          <div id={containerId} data-testid={containerId} className="min-h-[120px]" />
        </motion.div>
      </div>
    </section>
  );
}
